module.exports = __webpack_public_path__ + "img/模版2.00269360.jpg";